import { FormControl, FormHelperText, OutlinedInputProps, Stack } from '@mui/material';
import React, { CSSProperties } from 'react';

import { StyledFormLabel, StyledOutlinedInput } from './StyledOutlinedInput';

interface BaseOutlinedInput {
  inputLabel?: string;
  isFullWidth?: boolean;
  customWidth?: CSSProperties['width'];
  size: OutlinedInputProps['size'];
  isRequired?: OutlinedInputProps['required'];
  isDisabled?: OutlinedInputProps['disabled'];
  placeholder?: OutlinedInputProps['placeholder'];
  id: OutlinedInputProps['id'];
  name?: OutlinedInputProps['name'];
  type?: OutlinedInputProps['type'];
  value: OutlinedInputProps['value'];
  onChange?: OutlinedInputProps['onChange'];
  errorMessage: string | null;
  clearAdornment?: OutlinedInputProps['endAdornment'];
  helperIcon?: React.ReactNode;
}

function BaseOutlinedInput(props: BaseOutlinedInput) {
  return (
    <FormControl
      required={props.isRequired}
      error={!!props.errorMessage}
      size={props.size}
      fullWidth={props.isFullWidth}
      sx={{ width: !props.isFullWidth ? props.customWidth : undefined }}
    >
      <Stack spacing={0.5}>
        {props.inputLabel ? <StyledFormLabel htmlFor={props.id}>{props.inputLabel}</StyledFormLabel> : null}
        <Stack
          direction={props.helperIcon ? 'row' : undefined}
          sx={{
            alignItems: props.helperIcon ? 'center' : undefined,
            justifyContent: props.helperIcon ? 'space-between' : undefined,
          }}
        >
          <StyledOutlinedInput
            id={props.id}
            name={props.name}
            placeholder={props.placeholder}
            type={props.type}
            value={props.value}
            onChange={props.onChange}
            required={props.isRequired}
            disabled={props.isDisabled}
            size={props.size}
            fullWidth={props.isFullWidth}
            endAdornment={props.clearAdornment}
          />
          {props.errorMessage && <FormHelperText>{props.errorMessage}</FormHelperText>}
          {props.helperIcon ? props.helperIcon : undefined}
        </Stack>
      </Stack>
    </FormControl>
  );
}

export default BaseOutlinedInput;
